import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante, usuarioPerfilFinanceiro } from '../../../usuario/usuario-perfil';


/** Acessos permitidos a carteira de prospects  */
export const acessosProspectCarteira: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente, usuarioPerfilFinanceiro];

@Injectable()
export class CanActivateProspectCarteira implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosProspectCarteira);
    }
}
